/**
 * 首页-核心技术 Mock 数据
 * 固定 6 个模块，后台可改：模块名、3 个功能描述、右下角图标
 * 真实接口返回结构应对齐：{ code: 200, data: { list: [...] } }
 */
export const coreTechnologyMockList = [
	{
		id: 1,
		name: '语音识别',
		features: [
			'>98%准确率',
			'<200ms 超低延迟',
			'支持十余种方言及带口音普通话',
		],
		icon: require('@/assets/img/home/center/asr.png'),
		sort: 1,
	},
	{
		id: 2,
		name: '自然语言处理',
		features: ['智能语义分句', '高效文本修正', '核心信息智能提取'],
		icon: require('@/assets/img/home/center/nsp.png'),
		sort: 2,
	},
	{
		id: 3,
		name: '多模态情绪分析',
		features: ['全通道实时分析', '多模态融合判断', '多维度情绪输出'],
		icon: require('@/assets/img/home/center/emotion.png'),
		sort: 3,
	},
	{
		id: 4,
		name: '声纹识别',
		features: ['多场景灵活采集', '无感身份验证', '注册内容无关'],
		icon: require('@/assets/img/home/center/voiceprint.png'),
		sort: 4,
	},
	{
		id: 5,
		name: '语音合成',
		features: ['自然流畅的听觉体验', '样本声音复刻', '场景化语音定制'],
		icon: require('@/assets/img/home/center/tts.png'),
		sort: 5,
	},
	{
		id: 6,
		name: '光学字符识别',
		features: ['极速图像解析', '全场景文字识别', '低算力友好部署'],
		icon: require('@/assets/img/home/center/ocr.png'),
		sort: 6,
	},
]
